import React from 'react';
import LazyLoad from 'react-lazyload';

const OrgFeatures = () => {
	return (
		<section className="section section-organizational-features" id="organizational-features">
			<div className="section-content row">
				<div className="col">
					<h2 className="title">Organizational Features</h2>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ require('../../../resources/img/icons/files-icon.png') }
									alt="Hanging Files"
								/>
							</LazyLoad>
						</div>
						<h3>Hanging Files</h3>
						<p>Keep important files like medical, business and financial paperwork more organized and protected.</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ require('../../../resources/img/icons/bill-clips-icon.png') }
									alt="Bill Clips"
								/>
							</LazyLoad>
						</div>
						<h3>Bill Clips</h3>
						<p>Keep cash flat and organized with bill clips that secure currency in place.</p>
					</div>
				</div>

				<div className="col sm-6 clear">
					<div className="callout">
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ require('../../../resources/img/icons/in-lid-organizer-icon.png') }
									alt="In&#45;Lid Organizer"
								/>
							</LazyLoad>
						</div>
						<h3>In&#45;Lid Organizer</h3>
						<p>For small valuables like passports, extra keys or media files that you want to access quickly, this storage section makes these items readily available.</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ require('../../../resources/img/icons/money-tray-icon.png') }
									alt="Money Tray"
								/>
							</LazyLoad>
						</div>
						<h3>Money Tray</h3>
						<p>The best way to store bills and coins, money trays keep cash organized and safe.</p>
					</div>
				</div>

				<div className="col sm-6 clear">
					<div className="callout">
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ require('../../../resources/img/icons/key-rack-icon.png') }
									alt="Key Rack"
								/>
							</LazyLoad>
						</div>
						<h3>Key Rack</h3>
						<p>Especially useful for business or property owners, key racks provide safe and secure organization for multiple keys.</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ require('../../../resources/img/icons/key-tag-icon.png') }
									alt="Key Tag"
								/>
							</LazyLoad>
						</div>
						<h3>Key Tag</h3>
						<p>Color&#45;coded tags and labels allow for easy organization of your keys.</p>
					</div>
				</div>

				<div className="col sm-6 clear">
					<div className="callout">
						<div className="image">
							<LazyLoad once={ true } offset={ 200 }>
								<img
									src={ require('../../../resources/img/icons/door-pocket-icon.png') }
									alt="Door Pocket"
								/>
							</LazyLoad>
						</div>
						<h3>Door Pocket</h3>
						<p>A deep door pocket that helps you keep your items safe, organized and easy to access.</p>
					</div>
				</div>
			</div>
		</section>
    );
};

export default OrgFeatures;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/OrgFeatures.js